import type { YammerState } from '../../state/types';
import { isFeatureRolloutEnabled } from '../featureRollouts/selectors';
import { getSession } from '../session/selectors';

type IsFlightControlPanelEnabledInConfig = (state: YammerState) => boolean;
export const isFlightControlPanelEnabledInConfig: IsFlightControlPanelEnabledInConfig = (state: YammerState) => {
  const session = getSession(state);

  return session && session.featureRollout ? session.featureRollout.enableFlightControlPanel : false;
};

type IsFlightControlPanelEnabled = (state: YammerState) => boolean;
export const isFlightControlPanelEnabled: IsFlightControlPanelEnabled = (state) =>
  isFeatureRolloutEnabled(state, 'FlightControlPanel') || isFlightControlPanelEnabledInConfig(state);
